import React from "react"
import PropTypes from "prop-types"
import Util from ".././../util"

import "./Money.scss";

function Money(props) {
  const vatInfo = props.displayVatInfo ? <div className="c-money-vat-info">inkl. MwSt.</div> : null;
  const className = props.total ? "c-money-total" : "c-money";
  return <>
    <span style={{whiteSpace:"nowrap"}} className={className}>
      {Util.Format.currency(props.amount, props.showCurrency, props.useDash)}
    </span>
    {vatInfo}
  </>
}

Money.propTypes = {
  showCurrency:PropTypes.bool.isRequired,
}
Money.defaultProps = {
  showCurrency:true,
  useDash:false,
  displayVatInfo:false
}


export default Money